module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/mastercard-old-53ace89eef66dbbfc76ca6d2f242b8f1.svg";